import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type { Collection } from '../collection'
import type { TypeParams } from '../types'

/**
 * When a responsible person is updated and marked as primary, reload the list
 * so primary status changes are reflected consistently.
 */
export const reloadResponsiblePersonsOnUpdate = store.effects.create(
  (_: ec.Collection<TypeParams>['feature'], collection: Collection) =>
    collection.plugins.editingPlugin.feature.actions.submit.success
      .observe()
      .pipe(
        rxjs.mergeMap(action =>
          action.data.response.updates
            .filter(update => TypeChecker.isTrue(update.data.isPrimary))
            .map(() =>
              collection.plugins.currentListPlugin.feature.actions.load
                .from('(effect) reload responsible persons on update')
                .create(),
            ),
        ),
      ),
)
